<template>
  <div>
    <div class="content" style="width:1000px">
    <aside class="aside">
      <strong>温馨提示</strong>
      <br />1.立即生效：充值套餐立即激活状态为【已停机】的流量卡，套餐立即生效并计算有效期。
      <br />2.下月生效：套餐次月生效，套餐生效后计算有效期，并激活状态为【已停机】的流量卡。
      <br />3.到期激活：卡购买的可用套餐，最后一个套餐的结束时间为开始时间。
    </aside>
    <el-form ref="propsParams" :rules="ruleValidate" :model="propsParams" label-width="200px" >
      <el-form-item label="资费套餐" prop="productId">
        <div class="select-button-container">
          <el-select v-model="propsParams.productId" filterable clearable placeholder="请选择资费套餐"  style="width:100%" >
            <el-option v-for="item in optPackage" :key="item.id" :label="labelProductName(item)" :value="item.id" @click.native="selectPackage(item)"></el-option>
          </el-select>
        </div>
      </el-form-item>

      <el-form-item v-if="adminShow" label="套餐价格">
        <el-input v-model="selectProductPrice.operationPrice" :disabled="true" style="width:100%"></el-input>
      </el-form-item>

      <el-form-item label="生效时间" prop="activationTime">
        <el-select v-model="propsParams.activationTime" filterable clearable placeholder="请选择生效时间">
          <el-option v-for="item in timeSet" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker v-if="propsParams.activationTime == '10'"
          v-model="propsParams.activeDateTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="请选择日期时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="上传方式" prop="fieldType" >
        <el-radio-group v-model="propsParams.fieldType" @input="switchFieldType">
          <el-radio  label="1" >批量组网号/ICCID</el-radio>
          <el-radio  label="2" >组网号段/ICCID范围</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="组网号/ICCID列表" prop="iccids" v-if="propsParams.fieldType == '1'">
        <el-input
          type="textarea"
          v-model="propsParams.iccids"
          rows="6"
          style="width:100%"
          @input="handleCardSum"
        ></el-input>
      </el-form-item>
      <el-form-item label="组网号/ICCID范围" prop="iccidRange" v-if="propsParams.fieldType == '2'">
        <el-row>
          <el-col :span="11">
            <el-input
              v-model="propsParams.startIccid"
              placeholder="包含起始值"
              clearable
              @paste.native="handlePaste"
            ></el-input>
          </el-col>
          <el-col :span="1" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-input
              v-model="propsParams.endIccid"
              placeholder="包含结束值"
              clearable
              @paste.native="handlePaste"
            ></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item v-if="number>0">
        <span style="top: -2px;color: #666;">共选择<em style="color:red">{{number}}</em>条数据</span>
      </el-form-item>
      <el-form-item label="订单金额" prop="totalPrice" v-if="!nextShow">
        <el-row>
          <el-col :span="6" v-if="userProductData.data.dw">
            <div>
              <el-statistic title="多网：">
                <template slot="formatter"> {{userProductData.data.dw.totalCard}}/{{userProductData.data.dw.totalMoney}}元</template>
              </el-statistic>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <el-statistic title="合计：">
                <template slot="formatter"> {{userProductData.totalCard}}/{{userProductData.totalPrice}}元 </template>
              </el-statistic>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="账户余额" prop="availAmount" v-if="!adminShow">
        <el-input v-model="availAmount" :disabled="true" style="width:100%"></el-input>
      </el-form-item>

      <!-- <el-form-item label="支付方式" prop="payType" v-if="!adminShow && !freeAgentShow">
        <ul class="payClass">
          <li v-for="(item,index) in payList" :key="index" :class="{cur:payIndex === index}" @click="curButton(item,index)"> {{item}}</li>
        </ul>
      </el-form-item> -->

      <el-form-item label="充值密码" prop="password"  :rules="this.payTypeShow ? ruleValidate.password : [{required : false}]" v-if="payTypeShow">
        <el-input v-model="propsParams.password" style="width:100%" placeholder="请输入充值密码" type="password"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" v-if="nextShow" @click="nextSubmit()">下一步</el-button>
        <el-button type="success" v-if="!nextShow" @click="handleSubmit()">立即支付</el-button>
      </el-form-item>
    </el-form>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible"
      @close="dialogClose"
      :lock-scroll="false"
      width="500px"
      v-dialogDrag
      center
      :close-on-click-modal="false">
        <p style="text-align: center;font-size: 18px;">订单总金额：{{resultObj.totalMoney}}元</p>
        <div :append-to-body="false" id="qrcodeDom" ></div>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import { productList } from "@/api/api.js"; //不分页套餐列表
import { userInfo } from "@/api/api.js";//获取个人中心的信息
import { userRechargeProductInfo , userSelectProductPrice } from "@/api/api.js";//获取个人中心的信息

import { orderRechargePayment } from "@/api/api.js";//计算价格
import { orderQueryRecharge } from "@/api/api.js";//查看订单是否支付
import QRCode from 'qrcodejs2'
export default {
  name:"multiNetOrder",
  components: {
  },
  data() {
    return {
      propsParams: {
        type:"1",
        productId:undefined,
        operatorId:undefined,
        activationTime:0,
        fieldType:"1",
        iccids:"",
        cardActive:false,
        payType:0,
        autoCharge:"0",
        autoCount:'1',
        startIccid:"",
        endIccid:""
      },

      levelCard:false,
      packagePrice:"",
      availAmount:"",
      totalPrice:0,
      operatorList:[],
      selectProductPrice:{},
      userProductData:{
        data:{
          dw:{totalCard:0,totalMoney:0},
        },
      },
      nextShow:true,
      ruleValidate: {
        productId: [
          { required: true, message: '请选择资费套餐', trigger: "blur" }
        ],
        password: [
          { required: true, message: '请输入充值密码', trigger: "blur" }
        ],
        iccids:[
          { required: true, message: '请输入组网号', trigger: "blur" }
        ],
        iccidRange:[
           { validator: this.validateIccidRange, trigger: ['blur', 'change'] }
        ],
      },
      timeSet:[
        {
          value: 0,
          label: '立即生效'
        }, {
          value: 1,
          label: '1个月'
        },{
          value: 4,
          label: '到期激活'
        }
      ],
      activationDay:1,
      optPackage:[],
      number:0,
      payList:['余额支付'],
      payIndex:0,
      payTypeShow:true,
      // 弹窗部分
      dialogVisible:false,
      dialogTitle:'确认支付',
      resultObj:{},
      timer:null,
      productData:[],
    };
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
    cardIccids(){
      return this.$route.params.iccids;
    },
  },
  methods: {
    // 资费套餐下拉
    queryServerList() {
      productList().then(res => {
        this.optPackage = res.data.data;
      });
    },
    // 初始化信息
    initData() {
      let params = {
				userId: this.$store.getters.user.userId
			};
      userInfo(params).then(res => {
        this.availAmount = res.data.data.availAmount;
      })
    },
    selectPackage(item){
      if(!item.id){
        return;
      }
      this.nextShow = true;
      this.handleSelectProduct(item.id)
    },
    //国内展示价格
    handleSelectProduct(productId){
      let type = "1"
      userSelectProductPrice({productId , type}).then(res=>{
        this.selectProductPrice = res.data.data
      })
    },
    labelProductName(item){
      return item.id + '-' + item.productName;
    },
    handleCardSum(){
      this.nextShow = true
      let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n"):[];
      this.number = iccids.filter(item=>!!item).length
      if(this.number == 0){
        this.$store.dispatch('ClearProductIccids')
      }else{
        this.$store.dispatch('CacheProductIccids', iccids.filter(item=>!!item).join(","))
      }
    },
    switchFieldType(label){
      this.nextShow = true
      if(label == '2'){
        this.number = 0
      }
      if(label == '1'){
        let iccids = this.propsParams.iccids ? this.propsParams.iccids.split("\n"):[];
        this.number = iccids.filter(item=>!!item).length
      }

    },
    nextSubmit(){
      this.$refs['propsParams'].validate((valid) => {
        if(valid){
          let { iccids } = this.propsParams;
          let params = {
            ...this.propsParams,
            iccids:iccids ? iccids.split("\n") : [],
          };
          userRechargeProductInfo(params).then(res=>{
            this.nextShow = false
            this.number = res.data.data.totalCard
            if(this.number == 0){
              this.nextShow = true
              this.$message.warning('输入的卡号都不存在，请重新输入！');
            }
            this.userProductData = res.data.data;
          })
        }
      })
    },
    handleSubmit() {
      this.$refs['propsParams'].validate((valid) => {
        if(valid){
          let { cardActive } = this.propsParams;
          let { iccids } = this.propsParams;
          let params = {
            ...this.propsParams,
            iccids:iccids ? iccids.split("\n") : [],
            cardActive:cardActive == true ? 1:0,
          };
          //管理员支付或者免费用户支付  弹出确认按钮
          if(this.adminShow){
            this.submitFreePay(params);
          }else{
            this.submitUserPay(params);
          }

        }
      })
    },
    submitFreePay(params){
      this.$alert("此次充值支付金额总计：0 元", '温馨提示', { confirmButtonText: '确定',})
      .then(() => {
        orderRechargePayment(params).then(res=>{
          if (res.data.code == 200) {
              this.$notify.info({
                title: "提示",
                message: "已提交充值，请在订单页面查看内容",
                duration: 1000,
                offset:30
              });
              this.resetSubmitForm()
              setTimeout(()=>{
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          }else{
              this.$message.error(res.data.message);
          }
        })
      })
      .catch(() => {
        this.$message.warning('取消充值');
      })
    },
    submitUserPay(params){
      if(params.payType == '0'){
          let money = this.userProductData.totalPrice
          this.$alert( `续费总金额：${money} 元`, '温馨提示', { confirmButtonText: '确认',})
          .then(() => {
            orderRechargePayment(params).then(res=>{
              if (res.data.code == 200) {
                  this.$notify.info({
                    title: '提示',
                    message: '余额支付完成',
                    duration: 1000,
                    offset:30
                  });
                  this.resetSubmitForm()
                  setTimeout(()=>{
                    this.$router.push({ path: `/taskCenter/missionList`});
                  },1000)
                  this.initData()
              }else if(res.data.code == 414){
                this.$message.warning('余额不足');
              }else{
                this.$message.error(res.data.message);
              }
            })
          })
          .catch(() => {
            this.$message.warning('取消充值');
          })
      }else{
        orderRechargePayment(params).then(res=>{
          if (res.data.code == 200) {
              this.resultObj = res.data.data;
              this.dialogVisible = true;
              this.$nextTick(()=>{
                document.getElementById("qrcodeDom").innerHTML=''; //先清空之前生成的二维码
                new QRCode('qrcodeDom',{
                  width: 344,
                  height:344,
                  text: res.data.data.result,  //需要转换的链接
                  render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                  background: '#f0f',   // 背景色
                  foreground: '#ff0'    // 前景色
                });
                this.isOrderPay()
              })
          }else if(res.data.code == 414){
            this.$message.warning('余额不足，请更换支付方式');
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
    },
    resetSubmitForm(){
      this.resetForm("propsParams");
      this.initData()
      this.propsParams.iccids = ""
      this.propsParams.startIccid = ""
      this.propsParams.endIccid = ""
      this.$store.dispatch('ClearProductIccids')
      this.nextShow = true
      this.number = 0
      //清空页面数据
      this.userProductData = {
        data:{
          dw:{totalCard:0,totalMoney:0},
        },
      }
      this.selectProductPrice = {}
      
    },
    isOrderPay(){
      this.timer = setInterval(() => {
        orderQueryRecharge({orderNum:this.resultObj.orderNum}).then(res =>{
          if(res.data.data == '3'){
            this.$notify.info({
              title: "提示",
              message: "已提交余额充值，请在订单页面查看内容",
              duration: 1000,
              offset:30
            });
            this.$store.dispatch('tagsView/delView', this.$route)
            this.$store.dispatch('ClearProductIccids')
            clearInterval(this.timer);
            this.timer = null;
            this.$router.push({ path: `/taskCenter/missionList`});
          }
        })
      },2000)
    },
    open(){
      this.$alert('账户余额不足，请前往【账户中心】充值。', '温馨提示', {
          confirmButtonText: '去充值',
      }).then(() => {
        this.$router.push('/users/onlinepay')
      })
    },
    curButton(item,index){
      this.payIndex = index;
      this.propsParams.payType = index;
      this.payTypeShow = index == 0 ? true:false;
    },
    dialogClose(){
      clearInterval(this.timer);
      this.timer = null;
    },
    validateIccidRange(rule, value, callback) {
      if (!this.propsParams.startIccid) {
        callback(new Error('请输入起始ICCID'));
      } else if (!this.propsParams.endIccid) {
        callback(new Error('请输入结束ICCID'));
      }else {
        callback();
      }
    },
    handlePaste(event){
      event.stopPropagation();
    },
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'multiNetOrder'){
          this.queryServerList();
          this.initData()
          if(!!this.cardIccids){
            this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
            this.number = this.propsParams.iccids.split("\n").length;
            this.nextShow = true;
            this.userProductData = {
              data:{
                dw:{totalCard:0,totalMoney:0},
              },
            };

          }
        }
      },
      deep: true
    }
  },
  created() {
    this.queryServerList();
    this.initData()
    if(!!this.cardIccids){
      this.propsParams.iccids = this.cardIccids.replace(/,/g, "\n");
      this.number = this.propsParams.iccids.split("\n").length;
      this.nextShow = true;
      this.userProductData = {
        data:{
          dw:{totalCard:0,totalMoney:0},
        },
      };

    }
    if(this.adminShow){
      this.timeSet = [
        {
          value: 0,
          label: '立即生效'
        }, {
          value: 1,
          label: '1个月'
        }, {
          value: 2,
          label: '3个月'
        }, {
          value: 3,
          label: '6个月'
        },{
          value: 4,
          label: '到期激活'
        },{
          value: 5,
          label: '卡停机激活'
        },{
          value: 10,
          label: '自定义时间'
        }
      ];
      this.levelCard = true
    }
  },
  mounted() {
  },
  beforeUnmount() {
  }
};
</script>
<style scoped lang="less">
.select-button-container {
  display: flex;
  align-items: center;
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-top: 10px;
  .custom-tag {
    margin: 0;
  }
}
  .aside {
    background: #eef1f6;
    padding: 20px 30px;
    margin-bottom: 20px;
    border-radius: 2px;
    display: block;
    line-height: 32px;
    font-size: 16px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    color: #2c3e50;
    -webkit-font-smoothing: antialiased;
    margin-left: 25px;
    width: 100%;
  }
  /deep/ .el-textarea.is-disabled .el-textarea__inner{
    color: #1E1E1E !important;
  }
  /deep/ .el-input.is-disabled .el-input__inner{
    color: #1E1E1E !important;
  }
  .sm-class{
    margin-left: 130px;
    margin-top: 50px;
  }
  .payClass{
    display: flex;
    li{
      margin-right: 20px;
      width: 125px;
      text-align: center;
      border: 1px solid #C0C4CC;;
    }
  }
  .cur{
    border: 1px solid #32c169 !important;
    background-image:url(~@/assets/img/wx_payImg2.png);
    background-repeat: no-repeat;
    background-position:13px 15px;
    background-size:110px;
  }

  #qrcodeDom{
    width:344px;
    height:344px;
    margin:0 auto;
  }

  @media screen and (max-width: 750px){
    /deep/ .el-form-item__label{
      width: 75px!important;
    }
   /deep/ .el-form-item__content{
     margin-left: 120px!important;
   }
  }

  .el-input-number-day {
      position: relative;
  }
  .el-input-number-day::after {
      content: '天';
      display: inline-block;
      height: 20px;
      line-height: 20px;
      width: 20px;
      text-align: center;
      position: absolute;
      right: 38px;
      top: 50%;
      transform: translateY(-50%);
  }
  .el-input-number-day .el-input__inner{
      padding-left: 30px;
      padding-right: 48px;
  }

</style>
